import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_TRANSACTIONS_DOWNLOAD: MijnRoute = {
    path: 'transacties-downloaden',
    navigationEvent: 'toTransactiesDownloaden',
    regex: /^\/zelf-regelen\/transacties-downloaden$/,
    webcomponent: 'mijn-transacties-downloaden-webcomponent'
};
